// extracted by mini-css-extract-plugin
module.exports = {"copy__block":"copy-module--copy__block--qXPp3","copy":"copy-module--copy--1iHSA"};